var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChampionS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 1.5H4H3V2.5L2.00006 2.5H1.00006V3.5V7.5H2.00006L3 7.5H4V3.5H4.00006V2.5L8.00012 2.5V3.5V7.5L9.00006 7.5L9.00012 7.5L10 7.5H11V3.5H11.0001V2.5H11H10H9.00012V1.5H9H8.00012ZM10 3.5V6.5H9.00012V3.5H10ZM3 6.5H2.00006V3.5H3V6.5ZM9 7.50003H3V8.50003H9V7.50003ZM5.5 8.50005H6.5V9.5H8.00012V10.5H6.5V10.5H5.5V10.5H4.00012V9.5H5.5V8.50005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionS);
export default __webpack_public_path__ + "static/media/champion-s.3070f2ddb28c318ce9df3cabea216ced.svg";
export { ForwardRef as ReactComponent };